<template>
  <IQOS :title="$t('online_payment.guide.title')" :readonly="true">
    <DashboardButton
      class="w-100"
      v-if="hasHelpModal"
      @click="$emit('guide')"
    >
      {{ $t("online_payment.help.title") }}
    </DashboardButton>
    <a
      class="merchant-register-link"
      :href="gatewayRegisterLink"
      target="_blank"
    >
      <DashboardButton variant="success" class="w-100 iqos-element-item">
        {{ $t("online_payment.guide.register_btn") }}
      </DashboardButton>
    </a>
    <DashboardButton
      variant="danger"
      @click="$emit('remove')"
      class="w-100 iqos-element-item"
    >
      {{ $t("online_payment.delete_merchant") }}
    </DashboardButton>
    <p class="comment c-grey">
      {{ $t("online_payment.guide.part1") }}
    </p>
    <p class="comment c-grey">
      {{ $t("online_payment.guide.part2") }}
    </p>
    <p class="comment c-grey">
      {{ $t("online_payment.guide.part3") }}
    </p>
    <p class="comment c-grey">
      {{ $t("online_payment.guide.part4") }}
    </p>
  </IQOS>
</template>

<script>
import IQOS from "@/components/IQOS.vue";
import IQOSActions from "@/components/IQOSActions.vue";
import BlackInput from "@/components/BlackInput.vue";
import DashboardButton from "@/components/DashboardButton.vue";

import MerchantGuideModal from "@/components/payment/MerchantGuideModal.vue";

export default {
  components: {
    IQOS,
    BlackInput,
    DashboardButton,
    MerchantGuideModal,
  },
  props: {
    merchant: Object,
  },
  data() {
    return {
      editing: false,
      help_modal: false,
    };
  },
  methods: {
    showEditUI() {
      this.editing = true;
    },
    hideEditUI() {
      this.editing = false;
      this.reset();
    },
    onEditFinish() {
      this.editing = false;
    },
    reset() {},
  },
  computed: {
    gatewayRegisterLink() {
      const links = {
        liqpay: "https://www.liqpay.ua/uk/registration",
        wayforpay: "https://wayforpay.com",
        payu: "https://corporate.payu.com",
        yookassa: "https://yookassa.ru/joinups",
        stripe: "https://stripe.com/",
        touchcard: 'https://touchcard.tech/#fedback',
        fondy: this.ownerLanguage == 'ru' ? 'https://fondy.ru' : 'https://fondy.ua',
        interkassa: 'https://www.interkassa.com/registration'
      };

      return links[this.merchant.gateway];
    },
    hasHelpModal() {
      return ["liqpay", "wayforpay", "stripe", "yookassa"].includes(
        this.merchant.gateway
      );
    },
    ownerLanguage() {
      return this.$store.state.owner.language;
    }
  },
  mounted() {
    this.reset();
  },
};
</script>

<style scoped>
.merchant-register-link {
  text-decoration: none !important;
}
</style>
